import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import Isvg from 'react-inlinesvg';
import Star from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_star.svg';
import css from './activity-percentage-bar.scss';

/**
 * ActivityPercentageBar component - displays activity percentage bar
 */
class ActivityPercentageBar extends Component {
    getClassName = (percentage) => {
        if (percentage >= 86 && percentage <= 100) {
            return css.mastered;
        } else if (percentage >= 66 && percentage <= 85) {
            return css.consolidating;
        } else if (percentage >= 50 && percentage <= 65) {
            return css.developing;
        } else if (percentage >= 26 && percentage <= 49) {
            return css.emerging;
        } else if (percentage >= 0 && percentage <= 25) {
            return css.needsImproving;
        }

        return null;
    };

    renderPercentage = (percentage) => {
        let percentageText;
        let fontColor;

        if (percentage > 100 || percentage < 0) {
            percentageText = '- %';
        } else {
            percentageText = `${percentage}%`;
            fontColor = css.white;
        }

        return (
            <div className={`${css.percentage} ${fontColor}`}>
                {percentageText}
            </div>
        );
    };

    renderStar = () => (
        <div className={css.icon}>
            <Isvg src={Star} cacheGetRequests />
        </div>
    );

    render() {
        const { percentage, hasGoldBar } = this.props;
        const className = this.getClassName(percentage);
        const width = !className ? '33px' : `${percentage}%`;

        return (
            <div
                className={`${css.container} ${className}`}
                style={{ width }}
                key={className}
            >
                {hasGoldBar && this.renderStar()}
                {this.renderPercentage(percentage)}
            </div>
        );
    }
}

ActivityPercentageBar.propTypes = {
    percentage: PropTypes.number,
    hasGoldBar: PropTypes.bool
};

export default styleable(css)(ActivityPercentageBar);



// WEBPACK FOOTER //
// ./components/activity-percentage-bar/activity-percentage-bar.js